class MCarousel extends HTMLElement {
  // Constantes de clase para selectors y clases
  static get SELECTORS() {
    return {
      CONTAINER: ".m-carousel__items",
      NAV_BUTTONS: ".m-carousel__nav-button",
      ITEMS: ".m-carousel__item",
      LINKS: ".m-carousel__items .c-box.--link",
      RIGHT_ARROW: ".e-icon.--arrow_right_md",
    };
  }

  constructor() {
    super();
    this.state = {
      currentTranslateX: 0,
      totalMoveDistance: 0,
      itemsMoved: 0,
      maxItemsMove: 0,
    };

    this.initializeElements();
    this.init();
  }

  /**
   * Inicializa las referencias a elementos del DOM
   */
  initializeElements() {
    const container = this.querySelector(MCarousel.SELECTORS.CONTAINER);
    console.log("Container found:", container);

    const items = container?.querySelectorAll(MCarousel.SELECTORS.ITEMS);
    console.log("Items found:", items);

    this.elements = {
      carouselContainer: container,
      navButtons: this.querySelectorAll(MCarousel.SELECTORS.NAV_BUTTONS),
      items: items || [],
      links: this.querySelectorAll(MCarousel.SELECTORS.LINKS),
    };
  }

  /**
   * Inicializa el componente
   */
  init() {
    this.setupEventListeners();
    this.calculateCarouselDimensions();
  }

  /**
   * Configura todos los event listeners
   */
  setupEventListeners() {
    this.setupHoverEffects();
    this.setupNavigation();
    this.setupResizeHandler();
  }

  /**
   * Configura el manejador de resize
   */
  setupResizeHandler() {
    const debouncedResize = this.debounce(() => {
      this.calculateCarouselDimensions();
      this.updateCarouselPosition();
    }, 250);

    window.addEventListener("resize", debouncedResize);
  }

  /**
   * Configura los efectos hover
   */
  setupHoverEffects() {
    this.elements.links.forEach((elem) => {
      elem.addEventListener("mouseover", () =>
        this.updateSiblingsOpacity(elem, "1")
      );
      elem.addEventListener("mouseout", () =>
        this.updateSiblingsOpacity(elem, "1")
      );
    });
  }

  /**
   * Actualiza la opacidad de los elementos hermanos
   */
  updateSiblingsOpacity(element, opacity) {
    this.getSiblings(element).forEach((sibling) => {
      sibling.style.opacity = opacity;
    });
  }

  /**
   * Obtiene los elementos hermanos de un elemento
   */
  getSiblings(element) {
    return Array.from(element.parentNode.children).filter(
      (child) => child !== element
    );
  }

  /**
   * Calcula las dimensiones del carousel
   */
  calculateCarouselDimensions() {
    if (!this.elements.items.length) return;

    const itemWidth = this.elements.items[0].offsetWidth;
    const gap = this.getColumnGap();
    this.state.totalMoveDistance = itemWidth + gap;

    const containerWidth = this.elements.carouselContainer.offsetWidth;
    const visibleItems = Math.floor(
      containerWidth / this.state.totalMoveDistance + 1
    );
    this.state.maxItemsMove = Math.max(
      0,
      this.elements.items.length - visibleItems
    );
  }

  /**
   * Obtiene el gap entre columnas
   */
  getColumnGap() {
    return (
      parseInt(
        window.getComputedStyle(this.elements.carouselContainer).columnGap,
        10
      ) || 0
    );
  }

  /**
   * Actualiza la posición del carousel
   */
  updateCarouselPosition() {
    this.state.currentTranslateX =
      -this.state.itemsMoved * this.state.totalMoveDistance;
    this.elements.carouselContainer.style.transform = `translateX(${this.state.currentTranslateX}px)`;
  }

  /**
   * Configura la navegación
   */
  setupNavigation() {
    this.elements.navButtons.forEach((button) => {
      button.addEventListener("click", () => this.handleNavigation(button));
    });
  }

  /**
   * Maneja la navegación
   */
  handleNavigation(button) {
    const isRightButton = button.querySelector(MCarousel.SELECTORS.RIGHT_ARROW);

    if (isRightButton && this.state.itemsMoved < this.state.maxItemsMove) {
      this.state.itemsMoved++;
    } else if (!isRightButton && this.state.itemsMoved > 0) {
      this.state.itemsMoved--;
    }

    this.updateCarouselPosition();
  }

  /**
   * Utilidad para hacer debounce de una función
   */
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

customElements.define("m-carousel", MCarousel);
